'use client';

import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';

const IsClientCtx = createContext<boolean>(false);

export const IsClientCtxProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const [isClient, setIsClient] = useState<boolean>(false);
  // useEffect only runs on client side, so this is an effective way to know if execution is client side
  useEffect(() => setIsClient(true), []);
  return (
    <IsClientCtx.Provider value={isClient}>{children}</IsClientCtx.Provider>
  );
};

export function useIsClient(): boolean {
  return useContext(IsClientCtx);
}
